export enum BackgroundColors {
  'darq_lightBrown' = 'bg-coffee1-50',
  'darq_lightGray' = 'bg-lightGray',
  'jasmin_lightGray' = 'bg-lightGrayVariant',
  'jasmin_lightGreen' = 'bg-green',
  'jasmin_darkGreen' = 'bg-pineGreen',
  'white' = 'bg-white',
  'black' = 'bg-black',
  'transparent' = 'bg-transparent'
}

const getBackgroundColor = (color?: keyof typeof BackgroundColors): string =>
  BackgroundColors[color ?? 'transparent'] ?? BackgroundColors['transparent']

export default getBackgroundColor
